"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var RadioGroup = function (_a) {
    var defaultValue = _a.defaultValue, name = _a.name, onChange = _a.onChange, value = _a.value, children = _a.children;
    return (react_1.default.createElement(RadioGroup_1.default, { defaultValue: defaultValue, name: name, onChange: onChange, value: value }, children));
};
exports.default = RadioGroup;
